import { NotifyEventType } from 'validator/notify_event_validator'
import { IIshikawaDiagram } from './../components/Ishikawa/types'
import { StatsCount, Count } from 'types/global'

/**
 * Interface padrão
 */
export interface INotification {
    unidade: string
    dataNotificacao: string
    dataOcorrencia: string
    id: string
    tipo: string
    status: string
    categoria: string
    notification_read: string
}

export interface INotificationArchiveBody {
    u_date_and_hour_notification_closed: string
    u_reason_for_archiving: string
    u_archiving_observations: string
    u_assigned_to: string
    u_state: string
}
export const notificationMock: INotification = {
    unidade: '',
    dataNotificacao: '',
    dataOcorrencia: '',
    id: '',
    tipo: '',
    status: '',
    categoria: '',
    notification_read: ''
}
/**
 * Interface para criação padrão
 */

export interface ICreateNewNotificationResponse {
    sys_id: string
    number: string
    record: string
    redirect_portal_url: string
    redirect_url: string
    table: string
    redirect_to: string
}
export interface ICreateNewNotification {
    sysparm_quantity: number
    variables: NotifyEventType
}
export interface ICreateNotification {
    sysparm_quantity: number
    variables: {
        u_observation_incident_classification?: string
        u_incident_classification: string
        u_image_risk: string
        u_oms_classification: string
        u_reclassified_incident_type: string
        notification_type: string
        reporter_name: string
        date_incident: string
        location_incident: string
        shift_incident: string
        reporter_sector: string
        incident_sector: string
        incident_type: string
        involves_patient: string
        damage_level: string
        document_type: string
        patient_initials: string
        patient_gender: string
        document_number: string
        patient_date_of_birth: string
        incident_title: string
        incident_description: string
        immediate_corrective_action: string
        contributing_mitigating_factors: string
        u_disclosure_comments: string
        u_disclosure: string
        u_never_events: string
        u_notification_multiplier: string
        u_attachments_url?: string
        u_attachments_string?: string
        u_attachments_size?: string
        u_probability_occurence?: number
        u_never_events_or_sentinel_event?: string
        u_never_events_reference?: string
        u_sentinel_event_jci?: string
    }
}
export const NotificationTypeInitiator: ICreateNotification = {
    sysparm_quantity: 0,
    variables: {
        u_observation_incident_classification: '',
        u_incident_classification: '',
        u_image_risk: '',
        u_oms_classification: '',
        u_reclassified_incident_type: '',
        notification_type: '',
        reporter_name: '',
        date_incident: '',
        location_incident: '',
        shift_incident: '',
        reporter_sector: '',
        incident_sector: '',
        incident_type: '',
        involves_patient: '',
        damage_level: '',
        document_type: '',
        patient_initials: '',
        patient_gender: '',
        document_number: '',
        patient_date_of_birth: '',
        incident_title: '',
        incident_description: '',
        immediate_corrective_action: '',
        contributing_mitigating_factors: '',
        u_disclosure_comments: '',
        u_disclosure: '',
        u_never_events: '',
        u_notification_multiplier: '',
        u_attachments_url: '',
        u_attachments_string: '',
        u_attachments_size: '',
        u_never_events_or_sentinel_event: '',
        u_never_events_reference: '',
        u_sentinel_event_jci: ''
    }
}
/**
 * Interface para redux action
 */
export interface INotificationAction {
    type: string
    payload: any
}
/**
 * Interface para objeto reducer
 */
export interface INotificationPlan {
    sys_id: string
    how: string
    how_much: string
    what: string
    when: string
    where: string
    who: string
    why: string
    u_do_not_perform_optional: string
    hospital_incident: {
        link: string
        value: string
    }
    number: string
    sys_mod_count: string
    sys_created_by: string
    sys_updated_on: string
}
export type FactorType = {
    element: string
    label: string
    sys_id: string
    value: string
    u_category_factors_version?: string
}
export type LabelValuePer = {
    label: string
    value: string
    index?: number
}
export type LondonVariblesTypes = {
    types_of_diagnosis: LabelValuePer[]
    probability: LabelValuePer[]
    tolerability_analysis: LabelValuePer[]
    sentinel_event: LabelValuePer[]
    organizational_consequences: LabelValuePer[]
}
type DisplayAndValuePer = {
    display_value: string
    value: string
}
export interface NotificationType {
    u_managers_review?: DisplayAndValuePer
    u_date_and_time_closed_by_manager?: DisplayAndValuePer
    u_observation_incident_classification?: DisplayAndValuePer
    u_note_external_notification?: DisplayAndValuePer
    date_of_patient_admission?: DisplayAndValuePer
    u_date_and_hour_notification_closed?: DisplayAndValuePer
    u_certifier_accreditor_protocol?: DisplayAndValuePer
    u_reclassified_incident_type?: DisplayAndValuePer
    u_incident_classification_external?: DisplayAndValuePer
    chronological_report?: DisplayAndValuePer
    incident_identifier?: DisplayAndValuePer
    contributing_mitigating_factors?: DisplayAndValuePer
    damage_level?: DisplayAndValuePer
    'damage_level.duration_secs'?: DisplayAndValuePer
    date_incident?: DisplayAndValuePer
    document_number?: DisplayAndValuePer
    document_type?: DisplayAndValuePer
    forwarded_by?: DisplayAndValuePer
    immediate_corrective_action?: DisplayAndValuePer
    incident_description?: DisplayAndValuePer
    incident_sector?: DisplayAndValuePer
    incident_title?: DisplayAndValuePer
    incident_type?: DisplayAndValuePer
    involves_patient?: DisplayAndValuePer
    location_incident?: DisplayAndValuePer
    mitigating_factors?: DisplayAndValuePer
    notification_type?: DisplayAndValuePer
    number?: DisplayAndValuePer
    patient_date_of_birth?: DisplayAndValuePer
    patient_gender?: DisplayAndValuePer
    patient_initials?: DisplayAndValuePer
    reporter_name?: DisplayAndValuePer
    reporter_sector?: DisplayAndValuePer
    shift_incident?: DisplayAndValuePer
    sys_class_name?: DisplayAndValuePer
    sys_created_by?: DisplayAndValuePer
    sys_created_on?: DisplayAndValuePer
    sys_id?: DisplayAndValuePer
    sys_mod_count?: DisplayAndValuePer
    sys_updated_by?: DisplayAndValuePer
    sys_updated_on?: DisplayAndValuePer
    u_archiving_observations?: DisplayAndValuePer
    u_assigned_to?: DisplayAndValuePer
    u_categorized_contributing_factor?: DisplayAndValuePer
    u_certifier_accreditor_pr?: DisplayAndValuePer
    u_date_and_hour_notificat?: DisplayAndValuePer
    u_date_and_time_closed_by?: DisplayAndValuePer
    u_image_risk?: DisplayAndValuePer
    u_incident_classification?: DisplayAndValuePer
    u_note_external_notificat?: DisplayAndValuePer
    u_notification_read?: DisplayAndValuePer
    u_observation_incident_cl?: DisplayAndValuePer
    u_oms_classification?: DisplayAndValuePer
    u_never_events?: DisplayAndValuePer
    u_reason_for_archiving?: DisplayAndValuePer
    u_state?: DisplayAndValuePer
    u_treatment_by?: DisplayAndValuePer
    u_disclosure?: DisplayAndValuePer
    u_disclosure_comments?: DisplayAndValuePer
    u_number_patients_involved?: DisplayAndValuePer
    u_notification_multiplier?: DisplayAndValuePer
    u_attachments_url?: DisplayAndValuePer
    u_attachments_string?: DisplayAndValuePer
    u_attachments_size?: DisplayAndValuePer
    u_probability_occurence?: DisplayAndValuePer
    u_version?: DisplayAndValuePer
    u_never_events_or_sentinel_event?: DisplayAndValuePer
    u_never_events_reference?: DisplayAndValuePer
    u_sentinel_event_jci?: DisplayAndValuePer
    u_treatment_group?: DisplayAndValuePer
    u_sub_state?: DisplayAndValuePer
    u_reopening_date?: DisplayAndValuePer
    u_sub_damage_level?: DisplayAndValuePer
}

export interface IIshikawaCategory {
    title: string
    causes: string[]
}

export interface INotificationReducer {
    notificationsCsvReport: string
    notificationsList: NotificationType[]
    notificationsPerMonthCount: NotificationGetCountField[]
    notificationsPerUnityCount: NotificationGetCountField[]
    notificationsPerSectorCount: NotificationGetCountField[]
    notificationsPerIncidentSectorCount: NotificationGetCountField[]
    mostReclassifiedIncidentType: NotificationGetCountField[]
    notificationsPerOmsCount: NotificationGetCountField[]
    notificationsPerDamageCount: NotificationGetCountFieldIndex[]
    autoNotification: number
    notificationsListByStatus: any
    loading: boolean
    loadingStats: boolean
    error: boolean
    notificationCount: number
    notificationCountByStatus: NotificationGetCountGroupBy
    finalizedBySubStatus?: {
        withTreatment: number
        withoutTreatment: number
    }
    notificationCountBySubDamageLevel?: { value: string; count: number }[]
    multiplierStats?: {
        totalNotifications: number
        totalMultiplier: number
    }
    sumOfTimeEventToNotification: {
        totalSeconds: number
        totalNotifications: number
    }
    notificationSelected?: any
    notificationScreen?: any
    damageLevel: any[]
    typesOfDiagnosis?: any
    multipleInfo: { qnt: number; total: number }
    factors?: {
        patient_factors?: FactorType[]
        individual_factors_people?: FactorType[]
        work_environment_factors?: FactorType[]
        organizational_and_managerial_factors?: FactorType[]
        team_factors_teams?: FactorType[]
        institutional_context_factors?: FactorType[]
        task_factors_and_technology?: FactorType[]
        technology_and_electronic_information_systems?: FactorType[]
        support_for_patients_families_and_staff?: FactorType[]
        nsp_opinion?: FactorType[]
    }
    londonVaribles?: LondonVariblesTypes
    sentinelEvent?: any
    neverEvents?: any
    notificationById?: NotificationType
    londonProtocol: ILondonProtocol
    ishikawaDiagram?: IIshikawaDiagram
    pacientFactors?: any
    actionPlans?: INotificationPlan[]
    accountabilityMatrix?: IAccountabilityMatrix
    notificationCreateCurrentStep?: number
    currentNavItem?: any
    progressBarNavClicked?: boolean
    notificationCountLastReclassifiedIncidentType?: any
    notificationProcessRequiredStepsRules?: NotificationProcessRequiredStepsRules
    // Propriedades específicas para Plano de Ação em Grupo
    actionPlansGroup?: INotificationPlan[]
    loadingGroup?: boolean
    errorGroup?: boolean
    // Propriedades para Plano de Ação em Massa (Batch)
    batchActionPlanLoading?: boolean
    batchActionPlanError?: string | null
    batchActionPlanResult?: IBatchActionPlanResponse | null
    // Propriedades para Ishikawa em Massa (Batch)
    batchIshikawaLoading?: boolean
    batchIshikawaError?: string | null
    batchIshikawaResult?: any | null
}
/**
 * Tipo para redux action
 */
export type NotificationAction = INotificationAction
/**
 * Tipo para lista padrão
 */
export type NotificationList = INotification[]

/**
 * Tipo padrão para notificacao
 */
export type Notification = INotification

/**
 * Tipo para reducer
 */
export type NotificationReducer = INotificationReducer
/**
 * Objeto padrão
 */

export const NotificationReducerTypeInitiator: INotificationReducer = {
    finalizedBySubStatus: undefined,
    notificationsCsvReport: '',
    loadingStats: false,
    sumOfTimeEventToNotification: { totalSeconds: 0, totalNotifications: 0 },
    notificationsList: [],
    notificationsPerUnityCount: [],
    notificationsPerSectorCount: [],
    notificationsPerIncidentSectorCount: [],
    notificationsPerMonthCount: [],
    mostReclassifiedIncidentType: [],
    notificationsPerOmsCount: [],
    notificationsPerDamageCount: [],
    notificationsListByStatus: [],
    loading: true,
    error: false,
    notificationCount: 0,
    autoNotification: 0,
    multipleInfo: { qnt: 0, total: 0 },
    notificationCountByStatus: {},
    notificationCountBySubDamageLevel: [],
    multiplierStats: {
        totalNotifications: 0,
        totalMultiplier: 0
    },
    notificationSelected: undefined,
    notificationById: undefined,
    ishikawaDiagram: undefined,
    londonProtocol: undefined,
    notificationCreateCurrentStep: 0,
    damageLevel: [],
    progressBarNavClicked: false,
    notificationCountLastReclassifiedIncidentType: null,
    notificationProcessRequiredStepsRules: null,
    // Estado inicial para Plano de Ação em Grupo
    actionPlansGroup: [],
    loadingGroup: false,
    errorGroup: false,
    // Estado inicial para Plano de Ação em Massa (Batch)
    batchActionPlanLoading: false,
    batchActionPlanError: null,
    batchActionPlanResult: null,
    // Estado inicial para Ishikawa em Massa (Batch)
    batchIshikawaLoading: false,
    batchIshikawaError: null,
    batchIshikawaResult: null
}

export interface ILondonProtocol {
    sys_id: string
    number: string
    chronological_report: string
    date_of_patient_admission: string
    do_not_perform_optional: string
    event_investigation_team: string
    identified_event: string
    individual_factors_people: string
    institutional_context_factors: string
    organizational_and_managerial_factors: string
    organizational_consequences?: string
    patient_factors: string
    patient_full_name: string
    patients_health_insurance: string
    probability: string
    processes_involved: string
    sentinel_event?: {
        link: string
        value: string
    }
    sys_created_by: string
    sys_created_on: string
    sys_mod_count: string
    sys_tags: string
    sys_updated_by: string
    sys_updated_on: string
    task_factors_and_technology: string
    team_factors_teams: string
    tolerability_analysis: string
    types_of_diagnosis: {
        link: string
        value: string
    }
    u_individual_factors_people_description: string
    u_institutional_context_factors_description: string
    u_non_compliance: boolean
    u_organizational_and_managerial_factors_description: string
    u_patient_care_number: string
    u_patient_factors_description: string
    u_risk_circumstance: string
    u_task_factors_and_technology_description: string
    u_team_factors_teams_description: string
    u_work_environment_factors_description: string
    work_environment_factors: string
    work_group: string
    oms_classification: string
    u_never_events: string
    hospital_incident: {
        link: string
        value: string
    }
    u_version: 'v1' | 'v2' | 'v3' | 'v4'
    u_strengths_of_the_care_provided_and_problems_in_managing_care: string
    u_data_source_and_methods: string
    u_technology_and_electronic_information_systems: string
    u_description_technology_and_electronic_information_systems: string
    u_support_for_patients_families_and_staff: string
    u_description_support_for_patients_families_and_staff: string
    u_nsp_opinion: string
    u_description_nsp_opinion: string
}

export interface IAccountabilityMatrix {
    sys_id?: string
    do_not_perform_optional: string
    sys_created_by?: DisplayAndValuePer
    sys_created_on?: DisplayAndValuePer
    sys_updated_by?: DisplayAndValuePer
    sys_updated_on?: DisplayAndValuePer
    u_hospital_incident: string
    u_matrix_result?: string
    u_question_01: DisplayAndValuePer
    u_question_02: DisplayAndValuePer
    u_question_03?: DisplayAndValuePer
    u_question_04?: DisplayAndValuePer
    u_question_05?: DisplayAndValuePer
    u_question_06?: DisplayAndValuePer
    u_question_07?: DisplayAndValuePer
    u_question_08?: DisplayAndValuePer
    u_question_09?: DisplayAndValuePer
    u_question_10?: DisplayAndValuePer
}

// Interfaces para Ishikawa Diagram
export interface IIshikawaPayload {
    hospital_incident: string
    sys_id?: string
    description?: string
    method?: string           
    manpower?: string         
    material?: string         
    measurement?: string      
    environment?: string      
    machine?: string          
    do_not_perform_optional?: string  
}

export interface IBatchIshikawaRequest {
    records: IIshikawaPayload[]
    options: {
        stopOnError: boolean
    }
}

export interface IBatchIshikawaResponse {
    success: boolean
    results?: any[]
    errors?: any[]
}


//notification plan
export interface ICreateNotificationPlanPayLoad {
    hospital_incident: string
    how?: string
    how_much?: string
    what?: string
    when?: string
    where?: string
    who?: string
    why?: string
    u_notifica_user?: string
    u_do_not_perform_optional?: string
}

// Batch action plan interfaces
export interface IBatchActionPlanRecord extends ICreateNotificationPlanPayLoad {
    u_notifica_user: string
}

export interface IBatchActionPlanOptions {
    stopOnError?: boolean
}
export interface IBatchActionPlanRequest {
    records: IBatchActionPlanRecord[]
    options?: IBatchActionPlanOptions
}

export interface IBatchActionPlanError {
    index: number
    record: IBatchActionPlanRecord
    error: string | any
    status: number
}

export interface IBatchActionPlanResponse {
    success: boolean
    message: string
    processed: number
    created: number
    errors: number
    validation_errors: number
    processing_errors: number
    results: any[]
    error_details?: IBatchActionPlanError[]
}

/**
 * Tipo usado no Axios para retorno da contagem de notificacao
 */
export type ResultNotificationGetCount = IResultNotificationGetCount
export interface IResultNotificationGetCount {
    result: NotificationStatsCount
}
export type NotificationStatsCount = StatsCount

export type ResultNotificationGetCountGroupBy =
    IResultNotificationGetCountGroupBy

export type NotificationGetCountGroupBy = INotificationGetCountGroupBy

export type NotificationGetCountGroupBFetch = {
    groupby_fields: { field: string; value: string }[]
    stats: { count: string }
}
export interface IResultNotificationGetCountGroupBy {
    result: NotificationGetCountGroupBFetch[]
}

export interface INotificationGetCountGroupBy {
    [key: string]: {
        label: string
        count: string
        value: string
    }
}

export interface NotificationGetCountField {
    field: string
    value: string
}

export interface NotificationGetCountPerMonth {
    month: string
    value: number
}
export interface NotificationGetCountFieldIndex {
    field: string
    value: string
    index: string
}

/**
 * Tipo usado no Axios para retorno lista de notificacao paginado
 */
export type ResultNotificationGetAllPaginate = IResultNotificationGetAllPaginate

export interface IResultNotificationGetAllPaginate {
    result: NotificationList
}

/**
 * Tipo usado no Axios para retorno lista de notificacao por status
 */
export type ResultNotificationByStatus = IResultNotificationByStatus

export interface IResultNotificationByStatus {
    result: NotificationList
}

/**
 * Tipo usado no Axios para retorno de notificacao por id
 */
export type ResultNotificationGetById = IResultNotificationById
export interface IResultNotificationById {
    result: Notification[]
}

export type ResultNotificationActionPlan = IResultNotificationActionPlan
export interface IResultNotificationActionPlan {
    result: INotificationPlan[]
}
/**
 * Tipo usado no objeto de regras de obrigatoridade de acordo com a matrix de risco.
 */

export enum EnumNotificationProcessRequiredStepsRulesStatus {
    Optional = 'Optional',
    Required = 'Required',
    // 'Dispensable' foi descontinuado apos atualização da matriz de dano
    // Dispensable = 'Dispensable'
}
export type NotificationProcessRequiredStepsRules =
    INotificationProcessRequiredStepsRules
export interface INotificationProcessRequiredStepsRules {
    currentStepTreatments: number[]
    ishikawaMandatory: EnumNotificationProcessRequiredStepsRulesStatus
    londonProtocolMandatory: EnumNotificationProcessRequiredStepsRulesStatus
    accountabilityMatrixMandatory: EnumNotificationProcessRequiredStepsRulesStatus
    actionPlanMandatory: EnumNotificationProcessRequiredStepsRulesStatus
    summaryProbabilityOccurence?: string
    currentStepSelected?: number
}
